import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HttpProxyService {
  proxy: boolean = environment.proxy;
  backendApiUrl: string = environment.backendApiUrl;
  apiUrl: String = environment.nodeApiUrl;
  constructor(public http: HttpClient) {
    let hostName = document.location.hostname;
    if (hostName != 'localhost') this.backendApiUrl = window.location.protocol + '//' + hostName;
    else {
      this.backendApiUrl = environment.backendApiUrl;
    }
  }

  get(url, header = null) {
    if (this.backendApiUrl) {
      let hostName = this.extractHostname(url);
      if (hostName.indexOf('.blob.core.windows.net') <= 0) url = url.replace(hostName, this.backendApiUrl);
    }
    if (this.proxy) {
      let data = {
        url,
        method: 'get',
        header,
      };
      if (header) {
        return this.http.put(`${this.apiUrl}`, data, header);
      }
      return this.http.put(`${this.apiUrl}`, data);
    } else {
      let request;
      if (header) {
        request = this.http.get(url, header);
      } else {
        request = this.http.get(url);
      }
      return request;
    }
  }

  post(url, body = null, header = null) {
    if (this.backendApiUrl) url = url.replace(this.extractHostname(url), this.backendApiUrl);
    if (this.proxy) {
      let data = {
        url,
        method: 'post',
        data: body,
        header,
      };
      return this.http.put(`${this.apiUrl}`, data);
    } else {
      let request;
      if (header) {
        request = this.http.post(url, body, header);
      } else {
        request = this.http.post(url, body);
      }
      return request;
    }
  }

  put(url, body = null, header = null) {
    if (this.backendApiUrl) url = url.replace(this.extractHostname(url), this.backendApiUrl);
    if (this.proxy) {
      let data = {
        url,
        method: 'put',
        data: body,
        header,
      };
      return this.http.put(`${this.apiUrl}`, data);
    } else {
      let request;
      if (header) {
        request = this.http.put(url, body, header);
      } else {
        request = this.http.put(url, body);
      }
      return request;
    }
  }

  delete(url, body = null, header = null) {
    if (this.backendApiUrl) url = url.replace(this.extractHostname(url), this.backendApiUrl);
    if (this.proxy) {
      let data = {
        url,
        method: 'delete',
        data: body.body,
        header: body.headers,
      };
      return this.http.put(`${this.apiUrl}`, data);
    } else {
      let request;
      if (body) {
        request = this.http.delete(url, body);
      } else {
        request = this.http.delete(url);
      }
      return request;
    }
  }

  extractHostname(url) {
    var hostname;
    //find & remove protocol (http, ftp, etc.) and get hostname

    if (url.indexOf('//') > -1) {
      hostname = url.split('/')[2];
    } else {
      hostname = url.split('/')[0];
    }
    //find & remove "?"
    hostname = hostname.split('?')[0];

    return url.substr(0, url.indexOf('://')) + '://' + hostname;
  }
}
